/**************************************************
 * Nombre:       Formulario_Reserva.js
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {
    AccountCircleOutlined,
    FlagOutlined,
    Mail,
    SmartphoneOutlined,
    TableRestaurantOutlined,
    WhatsApp
} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {ESTADOSRESERVAS} from "../../Constantes";
import IngresoSelectFalsoVerdadero from "../../Modulo_formularios/Componentes/IngresoSelectFalsoVerdadero";
import IngresoTextoBoton from "../../Modulo_formularios/Componentes/IngresoTextoBoton";
import {iniciarChatWass} from "../../Modulo_ChatWass/Funciones/iniciarChatWass";
import {PAISESINDICATIVO} from "../../Modulo_ChatWass/Utilidades/indicativos";
import IngresoFecha from "../../Modulo_formularios/Componentes/IngresoFecha";
import IngresoHora from "../../Modulo_formularios/Componentes/IngresoHora";
import {useState} from "react";
import {buscarMesasDisponiblesDiaHora} from "../../CodNegocio/Mesas/buscarMesasDisponiblesDiaHora";

const Formulario_Reserva = ({...props}) => {



    const chatWhatsApp = (num) => {

        iniciarChatWass({numero: props.props.getValues("celular"), pais: props.props.getValues("pais"), local: false});

    }

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoSelect Icono={FlagOutlined} nombre={'Estado'} {...props} dato={'estado'}
                                   opciones={ESTADOSRESERVAS.map((it) => it.nombre)}
                    />
                </Grid>


                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoSelectFalsoVerdadero Icono={FlagOutlined} nombre={'Notificaciones'} {...props}
                                                 dato={'notificaciones'}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography>Datos Potencial</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre'} dato={'nombre'} {...props}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoSelect Icono={FlagOutlined} nombre={'Pais'} dato={'pais'} {...props}
                                   opciones={PAISESINDICATIVO.map((it) => it.nameES)}

                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTextoBoton Icono={SmartphoneOutlined} nombre={'Celular'} dato={'celular'} {...props}
                                       click={chatWhatsApp} IconoFinal={WhatsApp}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={Mail} nombre={'Correo'} dato={'correo'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoFecha nombre={'Fecha'} dato={'fechaInicio'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoHora nombre={'Hora'} dato={'horaInicio'} {...props}
                                 requerido={'Campo requerido'} intervalo={30}
                    />
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto nombre={'Tiempo a quedarse (Horas)'} dato={'numHoras'} {...props}
                                  requerido={'Campo requerido'} type={'number'}
                    />
                </Grid>

            </Grid>

        </form>

    )

}
export default Formulario_Reserva